document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('.section-contact-form .contact-form__form');

  forms.forEach(form => {
    if (form.hasAttribute('data-contact-form-bound')) return;
    form.setAttribute('data-contact-form-bound', 'true');

    form.addEventListener('submit', function(event) {
      const honeypot = form.querySelector('.contact-form__honeypot input');
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
      }
    });
  });

  const success = document.querySelector('.section-contact-form .contact-form__success');
  if (success) {
    success.focus({ preventScroll: true });
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
});
